export default __webpack_public_path__ + "bg_anli_nengyuan01b96fed.png";